import { Injectable, inject } from '@angular/core';
// import * as Raven from 'raven-js';
import { EnvironmentService } from './environment.service';


/**
 * TODO: [AR] IMPLEMENT USING NEW SENTRY SDK
 */
@Injectable({
  providedIn: 'root'
})
export class SentryService {
  private environmentService = inject(EnvironmentService);

  // private url;
  private initialized = false;

  init() {
    const environment = this.environmentService.resolve();

    if (environment.envName === 'prod') {
      // this.url = 'https://6f53bf0d908341ff9f415d60b4b1c7d2@sentry.io/296513';
    } else {
      // this.url = 'https://b14f5659358a44febad58b272f6f5920@sentry.io/296512';
    }

    try {
      // Raven
      //   .config(this.url)
      //   .install();
      this.initialized = true;
    } catch {
      this.initialized = false;
    }
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  handleError(_: any) {
    // Raven.captureException(error.originalError || error);
  }
}
